import { createContext } from "react";

export const UserCustomFieldContext = createContext({
  fields: [],
  setFields: () => {}
})